import { render, staticRenderFns } from "./InterventionDettails.vue?vue&type=template&id=0e2b1392&"
import script from "./InterventionDettails.vue?vue&type=script&lang=js&"
export * from "./InterventionDettails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports